import { render, staticRenderFns } from "./NoResultMessage.vue?vue&type=template&id=60402c94&scoped=true&lang=pug&"
import script from "./NoResultMessage.vue?vue&type=script&lang=ts&"
export * from "./NoResultMessage.vue?vue&type=script&lang=ts&"
import style0 from "./NoResultMessage.vue?vue&type=style&index=0&id=60402c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60402c94",
  null
  
)

export default component.exports